import { render, staticRenderFns } from "./Tag-Soste.vue?vue&type=template&id=1b5769f8&scoped=true&lang=pug"
import script from "./Tag-Soste.vue?vue&type=script&lang=js"
export * from "./Tag-Soste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5769f8",
  null
  
)

export default component.exports